import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { DashboardData, PersonInfo } from 'services/application/application.service';
import { ConfigService } from 'services/config/config.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private configSvc: ConfigService, private http: HttpClient) {}

    // #region Get Notifications Service Call
    GetNotifications(AuthToken: string, AsRole: string) {
        return this.http
            .get<NotificationsInfo>(
                this.configSvc.hostAddress +
                    `Api/Services/IRIS/GetNotifications?` +
                    `AuthToken=${AuthToken || ''}&CurrentRole=${AsRole || ''}`
            )
            .pipe(
                map(notices => {
                    if (notices) {
                        notices.LastLogin = notices.LastLogin ? new Date(notices.LastLogin) : null;

                        if (notices.Notifications && !!notices.Notifications.length) {
                            notices.Notifications.forEach(n => {
                                if (n.Details && !!n.Details.length) {
                                    n.Details.forEach(nd => {
                                        nd.DateReferred = nd.DateReferred ? new Date(nd.DateReferred) : null;
                                    });
                                }
                            });
                        }
                    }

                    return notices;
                })
            );
    }

    // #endregion
}

// #region Custom Classes

// #region Notification Detail

export class NotificationDetail {
    RequestID?: number;
    RequestIssueNumber?: number;
    ReferralID?: number;
    RequestSubject?: string;
    RequestorInfo?: PersonInfo;
    DateReferred?: Date;
    LinkState?: string;
    AsDesignee?: boolean;
}

// #endregion

// #region Notification Item

export class NotificationItem {
    Details?: NotificationDetail[];
    IconName?: string;
    LinkState?: string;
    Message?: string;
    SortOrder?: number;
}

// #endregion

// #region Notifications Info

export class NotificationsInfo {
    LastLogin?: Date;
    Notifications?: NotificationItem[];
    Statistics?: DashboardData;
}

// #endregion

// #endregion
